{
    "signUp": {
        "prefix": "signUp",
        "nav": null
    }
}